/**
 * Controls the view frustum on infrascene.
 * Adapts slicing for views of a specific sensorgroup and adjusting the render
 * distance according to dataset configuration.
 */
export class FrustumHandler {
    constructor(scene, sensorgroup = 6, thickness = 0.01) {
        /**
         * Sensor group to apply the new frustum at. defaults to 6.
         */
        this._sensorgroup = 6;
        /**
         * thickness in m of the frustumr
         */
        this._thickness = 0.005;
        this._scene = null;
        this._original_far = 1200;
        this._slicing = true;
        this._scene = scene;
        this._sensorgroup = sensorgroup;
        this._thickness = thickness;
    }
    setRenderDistance(renderdistance) {
        this._original_far = renderdistance;
        this._setFar(renderdistance);
    }
    activateSlicer() {
        this._slicing = true;
        if (this._scene.getCurrentGeoFrameCollection())
            this._slice(this._scene.getCurrentGeoFrameCollection());
        this._gfcsubscription = this._scene.userinputapi.geoframecollectionchanged$.subscribe((gfc) => {
            this._slice(gfc);
        });
    }
    deactivateSlicer() {
        this._slicing = false;
        this._gfcsubscription.unsubscribe();
        if (this._scene.getCurrentGeoFrameCollection())
            this._slice(this._scene.getCurrentGeoFrameCollection());
    }
    _slice(geoframecollection) {
        const sensorgroup = geoframecollection.measureinfo.sensorgroup;
        if (sensorgroup != this._sensorgroup || !this._slicing) {
            this._setFar(this._original_far);
            return;
        }
        const focallength = geoframecollection.measureinfo.imagemeta.focallength * 0.001;
        const nearplane = focallength - this._thickness * 0.5;
        const farplane = focallength + this._thickness * 0.5;
        const s = nearplane / (geoframecollection.measureinfo.imagemeta.focallength * 0.001);
        const newpixsize = geoframecollection.measureinfo.imagemeta.pixsize * 0.000001 * s;
        this._scene.infrascene.sceneCamera.setCameraIntrinsics({
            FAR: farplane,
            NEAR: nearplane,
            PIXEL_SIZE: newpixsize,
        });
        this._scene.infrascene.render();
    }
    _setFar(far = 1200) {
        this._scene.infrascene.sceneCamera.setCameraIntrinsics({ FAR: far });
        if (this._scene.infrascene.panoCamera != null) {
            this._scene.infrascene.panoCamera.setCameraIntrinsics({ FAR: far });
        }
        if (this._scene.infrascene.multiperspectiveCamera != null) {
            this._scene.infrascene.multiperspectiveCamera.setCameraIntrinsics({ FAR: far });
        }
        this._scene.infrascene.render();
    }
}
//# sourceMappingURL=frustumhandler.js.map